export default {
  title: "Admin livraison",
  titleFr: "Admin livraison",
  footerWechatDev: "Développement WeChat",
  footerWechatApp: "Applications WeChat",
  footerMiniProgram: "Mini-programmes",
  footerPowered: "Propulsé par",
  footerW7: "We7",
};
